module.exports = __webpack_public_path__ + "img/terms-icons.18cad465.png";